import axios from "axios";
import {Message} from "element-ui";
import * as cache from "./cache";
import i18n from '../locales'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 55000
});

// 请求前拦截，设置Token
service.interceptors.request.use(config => {
  config.data = JSON.stringify(config.data);
  config.headers = {
    "Content-Type": "application/json",
    "Authorization": cache.getToken()
  }
  return config
}, error => {
  Promise.reject(error);
});

// 响应拦截,数据验证
service.interceptors.response.use(
  response => {
    const reData = response.data;
    //1.1 授权失败
    if (reData.errorCode == 0) {
      return reData;
    }
    //1.2 授权失效
    else if (reData.errorCode == -1) {
      cache.removeAuth();
      Message({
        type: "error",
        duration: 1500,
        message: "Authorization expired, please log in again(" + reData.errorMessage + ")",
        onClose: () => {
          if (parent) {
            parent.window.location.href = "/#/login";
          } else {
            window.location.href = "/#/login";
          }
        }
      });
      // 返回错误
      return Promise.reject("error");
    }
    //1.3 业务错误
    else {
      const errorMappings = {
        "Incorrect password.": "activity_login_warning3",
        "Please log in using a third-party account.": "activity_register_warning2",
        "This email has not been registered.": "activity_account_not_register",
        "This email has been registered on this app.": "activity_register_warning1",
        "This email does not require registration, please log in using a third-party account.": "activity_register_warning2",
        "After 5 consecutive incorrect password attempts, the current user has been locked for 15 minutes. Please try again later.": "activity_login_warning2"
      };
      const messageKey = errorMappings[reData.errorMessage] || null;
      const strErrorMessage = messageKey ? i18n.t(messageKey) : reData.errorMessage;

      Message({type: "error", duration: 3 * 1000, message: strErrorMessage});
      return Promise.reject("error");

    }
  },
  error => {
    if ("Network Error" == error.message) {
      Message({type: "error", duration: 3 * 1000, message: "Network connection abnormal, please confirm network connection"});
    } else {
      Message({type: "error", duration: 3 * 1000, message: error.message});
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js